<template>
  <div :style="{ padding: '0 50px', marginTop: '64px', zIndex: 1 }">
    <div :style="{ background: '#fff', padding: '24px', minHeight: '800px' }">
      <section>
        <lottie-player
          src="https://assets8.lottiefiles.com/packages/lf20_KxADqK.json"
          background="transparent"
          speed="3"
          style="width: 100%; height: 400px"
          loop
          autoplay
        ></lottie-player>
        <a-row id="contact">
          <a-col :span="6" :xs="24" :sm="24" :md="12" :lg="6">
            <lottie-player
              src="https://assets6.lottiefiles.com/packages/lf20_rbqdVs.json"
              background="transparent"
              speed="2"
              style="width: 300px; height: 180px"
              loop
              autoplay
            ></lottie-player>
            Bo Lan
            <a href="mailto:lanb@usc.edu"><a-icon type="mail" /></a>
          </a-col>
          <a-col :span="6" :xs="24" :sm="24" :md="12" :lg="6">
            <lottie-player
              src="https://assets6.lottiefiles.com/packages/lf20_15mU8Y.json"
              background="transparent"
              speed="2"
              style="width: 300px; height: 180px"
              loop
              autoplay
            ></lottie-player>
            Xinyi Yan
            <a href="mailto:yanxinyi@usc.edu"> <a-icon type="mail" /></a>
          </a-col>
          <a-col :span="6" :xs="24" :sm="24" :md="12" :lg="6">
            <lottie-player
              src="https://assets6.lottiefiles.com/packages/lf20_15mU8Y.json"
              background="transparent"
              speed="2"
              style="width: 300px; height: 180px"
              loop
              autoplay
            ></lottie-player>
            Yue Zeng
            <a href="mailto:yuezeng@usc.edu"> <a-icon type="mail" /></a>
          </a-col>
          <a-col :span="6" :xs="24" :sm="24" :md="12" :lg="6">
            <lottie-player
              src="https://assets6.lottiefiles.com/packages/lf20_15mU8Y.json"
              background="transparent"
              speed="2"
              style="width: 300px; height: 180px"
              loop
              autoplay
            ></lottie-player>
            Zilu Lin
            <a href="mailto:zilulin@usc.edu"> <a-icon type="mail" /></a>
          </a-col>
        </a-row>
        <!-- <div id="contact">
          <p>
            <a-icon type="user"></a-icon> Bo lan
            <a href="mailto:lanb@usc.edu"><a-icon type="mail" /></a>
            <a-icon type="user"></a-icon> Xinyi Yan
            <a href="mailto:yanxinyi@usc.edu"> <a-icon type="mail" /></a>
            <a-icon type="user"></a-icon> Yue Zeng
            <a href="mailto:yuezeng@usc.edu"> <a-icon type="mail" /></a>
            <a-icon type="user"></a-icon> Zilu Lin
            <a href="mailto:zilulin@usc.edu"> <a-icon type="mail" /></a>
          </p>
        </div> -->
      </section>
      <div class="test">
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style>
#intro {
  width: 100%;
  height: 60vh;
  position: relative;
  background: url(../assets/test.jpeg) top center;
  background-size: cover;
  background-color: rgba(1, 1, 1, 1);
}
.test p {
  font-size: 200%;
}
#contact {
  width: 100%;
  height: 10vh;
  /* margin-left: 16%; */
  margin-top: 3%;
  text-align: center;
}
#contact p {
  margin-top: 3%;
  font-size: 150%;
  color: black;
  text-shadow: 1px 1px rgb(129, 126, 126);
}
a {
  margin-left: 1%;
  margin-right: 11%;
}
a-icon {
  margin-right: 4%;
}
</style>
